/**
 * Analytics API Client
 * Frontend API calls for branch analytics
 */

import apiClient from './client';

/**
 * Get sales metrics for a branch
 */
export const getBranchSalesMetrics = async (branchId, startDate, endDate) => {
  const params = {};
  if (startDate) params.startDate = startDate;
  if (endDate) params.endDate = endDate;
  
  const response = await apiClient.get(`/analytics/branches/${branchId}/sales`, { params });
  return response.data;
};

/**
 * Get inventory metrics for a branch
 */
export const getBranchInventoryMetrics = async (branchId) => {
  const response = await apiClient.get(`/analytics/branches/${branchId}/inventory`);
  return response.data;
};

/**
 * Get staff performance for a branch
 */
export const getBranchStaffMetrics = async (branchId, startDate, endDate) => {
  const params = {};
  if (startDate) params.startDate = startDate;
  if (endDate) params.endDate = endDate;
  
  const response = await apiClient.get(`/analytics/branches/${branchId}/staff`, { params });
  return response.data;
};

/**
 * Get combined overview for branch dashboard
 */
export const getBranchOverview = async (branchId, startDate, endDate) => {
  const params = {};
  if (startDate) params.startDate = startDate;
  if (endDate) params.endDate = endDate;
  
  const response = await apiClient.get(`/analytics/branches/${branchId}/overview`, { params });
  return response.data;
};

/**
 * Get trending data for charts
 */
export const getBranchTrend = async (branchId, period = 'daily', days = 30) => {
  const response = await apiClient.get(`/analytics/branches/${branchId}/trend`, {
    params: { period, days }
  });
  return response.data;
};

/**
 * Get top selling products
 */
export const getTopProducts = async (branchId, limit = 10, startDate, endDate) => {
  const params = { limit };
  if (startDate) params.startDate = startDate;
  if (endDate) params.endDate = endDate;
  
  const response = await apiClient.get(`/analytics/branches/${branchId}/top-products`, { params });
  return response.data;
};

/**
 * Get consolidated metrics (retail_admin+)
 */
export const getConsolidatedMetrics = async (startDate, endDate) => {
  const params = {};
  if (startDate) params.startDate = startDate;
  if (endDate) params.endDate = endDate;
  
  const response = await apiClient.get('/analytics/consolidated', { params });
  return response.data;
};

/**
 * Compare multiple branches
 */
export const compareBranches = async (branchIds, startDate, endDate) => {
  const params = { branchIds: branchIds.join(',') };
  if (startDate) params.startDate = startDate;
  if (endDate) params.endDate = endDate;
  
  const response = await apiClient.get('/analytics/compare', { params });
  return response.data;
};

/**
 * Get pending transfers summary
 */
export const getPendingTransfersSummary = async (branchId = null) => {
  const params = {};
  if (branchId) params.branchId = branchId;
  
  const response = await apiClient.get('/analytics/transfers/pending', { params });
  return response.data;
};

export default {
  getBranchSalesMetrics,
  getBranchInventoryMetrics,
  getBranchStaffMetrics,
  getBranchOverview,
  getBranchTrend,
  getTopProducts,
  getConsolidatedMetrics,
  compareBranches,
  getPendingTransfersSummary
};
